window.arjoLinkListWithMobileDropdownModule =
  window.arjoLinkListWithMobileDropdownModule ||
  (() => {
    const state = {
      isInitialized: false,
      elements: {},
    };

    const selector = '.arjo-m-link-list-mobile-dropdown';
    const customEventName = 'linkListMobileDropdownExpanded';

    const setUp = () => {
      const els = [...document.querySelectorAll(selector)];
      els.forEach((el) => {
        const id = el.dataset.dropdownId;
        if (!id) return;
        const dropdown = el.querySelector(`${selector}__list`);
        state.elements[id] = (() => {
          const collapse = () => {
            dropdown.removeAttribute('expanded');
          };
          const clickHandler = () => {
            dropdown.toggleAttribute('expanded');
            if (dropdown.hasAttribute('expanded')) {
              const customEvent = new CustomEvent(customEventName, {
                detail: {
                  dropdownId: id,
                },
              });
              window.dispatchEvent(customEvent);
            }
          };
          el.querySelector(`${selector}__toggle`).addEventListener('click', clickHandler);

          return { collapse };
        })();
      });

      const customEventHandler = (e) => {
        Object.keys(state.elements).forEach((key) => {
          if (state.elements[key] && key != e.detail.dropdownId) state.elements[key].collapse();
        });
      };
      window.addEventListener(customEventName, customEventHandler);
    };
    const init = () => {
      if (state.isInitialized) return;
      setUp();
      state.isInitialized = true;
    };
    return { init };
  })();

window.addEventListener('load', window.arjoLinkListWithMobileDropdownModule.init);
